<template>
  <g-master :name="master.endpoint"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :parentData="parentData"
            :actions="false"
  >
  </g-master>
</template>
<script>
  export default {
    props: ['id_person'],
    data () {
      return {
        master: {
          endpoint: 'w_rpt_vacation',
          tableSetup: {
            actions: false,
            columns: [
              {title: 'Inicio', dataIndex: 'periodo_ini_desc', sorter: true},
              {title: 'Fin', dataIndex: 'periodo_fin_desc', sorter: true},
              {title: 'Dias', dataIndex: 'pendientes', sorter: true}
            ]
          }
        }
      }
    },
    computed: {
      parentData () {
        return {
          codigo: this.id_person
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/VacacionesPendientes.vue